const Created = "created";
const Quoted = "quoted";
const Success = "success";
const Failure = "failure";

function all(): string[] {
  return [Created, Quoted, Success, Failure];
}

export default {
  Created,
  Quoted,
  Success,
  Failure,
  all
};
